import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { ImageEditorComponent } from '../image-editor/image-editor.component';

@Component({
  selector: 'app-t-new-image-decompression',
  templateUrl: './t-new-image-decompression.component.html',
  styleUrls: ['./t-new-image-decompression.component.css']
})
export class TNewImageDecompressionComponent extends GeneralTeacherComponent {

  @ViewChild('imageEditor', {static: true}) imageEditor: ImageEditorComponent;

  image: string[][];
  compressedText: string;
  colors: string;
  highlight: boolean = false;

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute) {
    super(topicService, activatedRoute)
    this.title = this.get("newImageDecompression");
    this.type = "newImageDecompression";
  }

  ngAfterViewInit() {
    if (this.image) {
      this.imageEditor.setImage(this.image);
    }
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.compressedText = this.configuration.typespecifics.compressedText;
    this.highlight = this.configuration.typespecifics.highlight;
    let imageString = "";
    let counts = this.compressedText.split(/([0-9]+)/);

    for (let i = 1; i < counts.length; i += 2) {
      imageString = imageString.concat(counts[i + 1].repeat(+counts[i]));
    }

    this.image = imageString.match(/.{1,20}/g).map(v => v.split(""));
    this.imageEditor.setImage(this.image);
    if (this.compressedText.includes("w")) {
      this.colors = "bw";
    } else {
      this.colors = "cmyrgb";
    }
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/newImageDecompression.png";
    definition.level = 3;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.compressedText = this.compressedText;
    definition.typespecifics.highlight = this.highlight;
    definition.key = definition.key.concat("%", this.compressedText);
    return definition;
  }

  generate() {
    this.colors = Math.random() > 0.5 ? "bw": "cmyrgb";
    this.imageEditor.colors = this.colors;
    this.highlight = Math.random() > 0.5;
    this.image = this.imageEditor.possibleImages[Math.floor(Math.random() * this.imageEditor.possibleImages.length)];
    this.imageEditor.setImage(this.image);
  }

  /** compute the compressed text */
  computeCompressed() {
    this.image = this.imageEditor.getImage();
    let imageString = this.image.map(v => v.join("")).join("");
    let lastSign = "";
    let count = 0;

    let solution = "";
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          solution = solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }

    solution = solution.concat(count.toString(), lastSign);
    this.compressedText = solution;
  }

  reset(){
    super.reset();
    this.title  =this.get("newImageDecompression");
    this.colors = "bw";
    this.highlight = true;
    this.compressedText = "";
    this.imageEditor.initImage();
  }

}
